import React from 'react';

const NotFound = () => {
    const style = {padding: '100px 0', fontSize: '60px', textAlign: 'center'}
    return (
        <div>
            <h1 style={style}>404 - Not Found</h1>
        </div>
    );
};

export default NotFound;